module.exports = __webpack_public_path__ + "fonts/pt-astra-sans_regular.0750b2dc.ttf";